import axios from 'axios';
import customDataProvider from './customDataProvider';

const formatFieldErrors = (message) =>
  message
    .map((item) => `${item.field}: ${item.errors?.join(', ')}`)
    .filter((line) => line)
    .join('\n');

// The API describes what went wrong in the response body; keep `response` around so
// callers can still branch on the status code.
const apiError = (err, message) => Object.assign(new Error(message), { response: err.response });

const httpClient = (url, options = {}) => {
  return axios({
    method: options.method,
    url,
    params: options.urlParams ? options.urlParams : null,
    onUploadProgress: options.onUploadProgress || null,
    data: options.body,
    withCredentials: true,
  }).catch((err) => {
    if (err.response?.data?.statusCode === 401) {
      window.location.href = '/login';
      return Promise.resolve();
    }
    const message = err.response?.data?.message;
    if (Array.isArray(message)) {
      return Promise.reject(apiError(err, formatFieldErrors(message)));
    }
    if (typeof message === 'string' && message) {
      return Promise.reject(apiError(err, message));
    }
    return Promise.reject(err);
  });
};

// Legacy dataProvider that uses old v3-style API
const legacyDataProvider = customDataProvider(process.env.REACT_APP_API_URL, httpClient);

// Wrapper function that supports both v3 (function call) and v5 (object methods) API
const dataProviderWrapper = (type, resource, params) => {
  return legacyDataProvider(type, resource, params);
};

// Add v5 object methods to the function for react-admin v5 compatibility
dataProviderWrapper.getList = (resource, params) =>
  legacyDataProvider('GET_LIST', resource, params);
dataProviderWrapper.getOne = (resource, params) => legacyDataProvider('GET_ONE', resource, params);
dataProviderWrapper.getMany = (resource, params) =>
  legacyDataProvider('GET_MANY', resource, params);
dataProviderWrapper.getManyReference = (resource, params) =>
  legacyDataProvider('GET_MANY_REFERENCE', resource, params);
dataProviderWrapper.create = (resource, params) => legacyDataProvider('CREATE', resource, params);
dataProviderWrapper.update = (resource, params) => legacyDataProvider('UPDATE', resource, params);
dataProviderWrapper.updateMany = (resource, params) =>
  legacyDataProvider('UPDATE_MANY', resource, params);
dataProviderWrapper.delete = (resource, params) => legacyDataProvider('DELETE', resource, params);
dataProviderWrapper.deleteMany = (resource, params) =>
  legacyDataProvider('DELETE_MANY', resource, params);
export default dataProviderWrapper;
